// services/http/attachAuth.ts
import { appStore } from '../../contexts/store'
import { authDataAtom } from '../../domains/auth/AtomAuth'
import { authCleanupCommandAtom } from '../../domains/auth/AuthCommand'
import { apiClient } from '../../infra/http/apiClient'
import { isTokenExpired } from '../../share/utility'

export function attachAuthInterceptors() {
  apiClient.interceptors.request.use((config) => {
    const auth = appStore.get(authDataAtom)

    if (auth?.token) {
      if (isTokenExpired(auth.token)) {
        appStore.set(authCleanupCommandAtom)
        throw new Error('TOKEN_EXPIRED')
      }

      config.headers.Authorization = `Bearer ${auth.token}`
    }

    return config
  })

  // apiClient.interceptors.response.use(
  //   (res) => res,
  //   (error) => {
  //     if (error.response?.status === 401) {
  //       appStore.set(logoutCommandAtom, '401')
  //     }
  //     return Promise.reject(error)
  //   },
  // )
}
